module.exports = __webpack_public_path__ + "img/pc.20d60a15.png";